;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');

	Collection.Invites = Backbone.Collection.extend({
		model: Model.Invite,

		isNew: function() {
			return true;
		},

		addEmpty: function() {
			this.add({});
		}
	});

}(window, APP, Backbone, Marionette, $, _));